<template>
  <ChartWidget
    :title="$t('message.dashboard.widgetTitle.ratingDistribution')"
    :tooltip="$t('message.dashboard.widgetTooltip.ratingDistribution')"
    :dataset="dataset"
    :loading="loading"
    :action-handler="actionHandler"
  ></ChartWidget>
</template>

<script>
import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";
import ChartWidget from "@/components/Dashboard/base/ChartWidget";
import { RATING_CHART_COLOR } from "@/config/rating-chart-colors";

export default {
  name: "DashboardRatingDistributionWidget",
  components: {
    ChartWidget
  },
  mixins: [dashboardWidget],
  data() {
    return {
      dataset: []
    };
  },
  watch: {
    data() {
      this.createDataset();
    }
  },
  methods: {
    createDataset() {
      const getValues = key => ({
        name: this.$t("message.dashboard.ratingDistributionSerie", [key]),
        value: this.data[key].value.count,
        percentage: this.data[key].value.percentage,
        increase: this.data[key].change
      });

      this.dataset = [
        {
          ...getValues("5"),
          color: RATING_CHART_COLOR.RATING_5
        },
        {
          ...getValues("4"),
          color: RATING_CHART_COLOR.RATING_4
        },
        {
          ...getValues("3"),
          color: RATING_CHART_COLOR.RATING_3
        },
        {
          ...getValues("2"),
          color: RATING_CHART_COLOR.RATING_2
        },
        {
          ...getValues("1"),
          color: RATING_CHART_COLOR.RATING_1
        }
      ];
    }
  }
};
</script>
